// extracted by mini-css-extract-plugin
export default {"social-profiles-list":"style_social-profiles-list__z8NN4","socialProfilesList":"style_social-profiles-list__z8NN4"};